import { alertController } from '@ionic/vue';
import {  openAlertaV2 } from  '@/utilities/services/alert-utilities';
import { checkIP }  from '@/utilities/global_functions'
import { loadStorage } from '@/utilities/storage/storage-utilities-main'
//import { Browser } from '@capacitor/browser';
import { Geolocation } from '@capacitor/geolocation';


const consola = function(){ void(0) }; //consola
const DISTANCIA = 1000; 
const ENTORNO =  window.location.host.indexOf('beta.ges.digital')==-1; 

// PDVs con geolocalización alternativa: si un usuario de este PDV no está cerca
// de su PDV principal, se comprueba también contra estas coordenadas alternativas.
// Clave = código PDV, Valor = [latitud, longitud] del PDV alternativo.
const PDV_GEOLOC_ALTERNATIVAS = {
    '110': [40.3627574, -3.7160691]  // PDV 110 (Leganés) → PDV 150 (Av. Rafaela Ybarra, 131)
} 
//console.log( window.location, ENTORNO)

const openAlertaDistancia  = async function() {
    const alerta = await alertController
        .create({
            header: 'Operacion no permitida', 
            message: 'Esta operación no puede llevarse a cabo si no estas en el punto de venta',
            mode : "md",
            backdropDismiss: false, 
            buttons: ["Ok"]
        })
    await alerta.present();      
    const {data} = await alerta.onDidDismiss();
    consola(data)
    return false
}

const openAlertaDistanciaEntrega  = async function(distancia) {
    const dt = (parseInt(distancia/100))/10
    const alerta = await alertController
        .create({
            header: 'Uff, estas un poco lejos...', 
            message: `Parece que estas un poco lejos del punto de entrega que figura en el albarán (a unos ${dt} km).<br/>
                    Si es correcto y quieres seguir, confirma. <br/>
                    Si el error es de Google que no ha localizado bien la dirección, pulsa 'Es correcto, error de Google' y lo corregiremos.<br/>
                    En caso contrario cancela.`,
            mode : "md",
            backdropDismiss: false, 
            cssClass: 'custom-rutas-alert',  
            buttons: [  
                {
                  text: 'Cancelar',
                  role: 'cancel'                
                },
                {
                  text: 'Confirmar',   
                  role: 'confirm'
                },
                {
                    text: 'Es correcto, error de Google',   
                    role: 'correct'
                  },
  
              ]
        })
    await alerta.present();
    const {data, role} = await alerta.onDidDismiss();
    consola(data)
    if (role=='confirm'){
        return true
    }
    else if (role =='correct') {
        return false
    }
    else {
       return undefined
    }
}



const getPosition = function (options){
    return new Promise((resolve, reject) => 
        navigator.geolocation.getCurrentPosition(resolve, reject, options)
    );
}

const pdvDistance =  async function( control, pdv_in, silent){
    //console.log(window.location.host, ENTORNO )
    if (ENTORNO && ENTORNO === true) {
        return true
    }
    window.fake_console(control, typeof(control),  pdv_in, (typeof pdv_in === 'string' || pdv_in instanceof String) ? JSON.parse(pdv_in) : pdv_in)
    if ( control === true )    {    
        const loc = await getGeoloc(1000*60*10)

        window.fake_console('Localización obtenida: ', loc)
        
        // Validar que se obtuvo la geolocalización correctamente
        if (!loc || typeof loc.latitude === 'undefined' || typeof loc.longitude === 'undefined') {
            console.error('Error: No se pudo obtener la geolocalización');
            if (!silent) { await openAlertaDistancia(); }
            return undefined;
        }
        
        let pdv = (typeof pdv_in === 'string' || pdv_in instanceof String) ? JSON.parse(pdv_in) : pdv_in
        pdv = Array.isArray(pdv) ? {latitude : pdv[0], longitude : pdv[1]} : pdv
        
        // Validar que el PDV tenga coordenadas válidas
        if (!pdv || typeof pdv.latitude === 'undefined' || typeof pdv.longitude === 'undefined') {
            console.error('Error: PDV no tiene coordenadas válidas');
            if (!silent) { await openAlertaDistancia(); }
            return undefined;
        }
        
        window.fake_console( loc, pdv, pdv_in )
        const lat = (loc.latitude-pdv.latitude)*110120
        const lon = (loc.longitude-pdv.longitude)*85000
        const dist = Math.ceil(Math.sqrt(Math.pow(lat,2)  +Math.pow(lon,2) )-(loc.accuracy||0))

        window.fake_console( 'Distancia', dist, lat, lon )

        if ( dist > DISTANCIA ) {
            // Si el PDV tiene coordenadas alternativas, comprobar también contra ellas
            const pdv_code = await loadStorage('pdv')
            if (pdv_code && PDV_GEOLOC_ALTERNATIVAS[pdv_code]) {
                const alt_coords = PDV_GEOLOC_ALTERNATIVAS[pdv_code]
                const alt_pdv = { latitude: alt_coords[0], longitude: alt_coords[1] }
                const alt_lat = (loc.latitude - alt_pdv.latitude) * 110120
                const alt_lon = (loc.longitude - alt_pdv.longitude) * 85000
                const alt_dist = Math.ceil(Math.sqrt(Math.pow(alt_lat, 2) + Math.pow(alt_lon, 2)) - (loc.accuracy || 0))
                window.fake_console('PDV alternativo', pdv_code, alt_dist, alt_lat, alt_lon)
                if (alt_dist <= DISTANCIA) {
                    return true
                }
                console.error(`[UBIKU] PDV ${pdv_code} tiene geoloc alternativa pero tampoco está cerca. ` +
                    `Distancia PDV principal: ${dist}m, Distancia alternativa: ${alt_dist}m, ` +
                    `Ubicación usuario: [${loc.latitude}, ${loc.longitude}], ` +
                    `PDV principal: [${pdv.latitude}, ${pdv.longitude}], ` +
                    `PDV alternativo: [${alt_pdv.latitude}, ${alt_pdv.longitude}], ` +
                    `Umbral: ${DISTANCIA}m`)
            }

            if (!silent ) {await openAlertaDistancia()}
            return undefined 
        }
        else {
            return true 
        }
    }  
    else {
        return true 
    }
}


const entregaDistance =  async function( punto_entrega){
        const loc = await getGeoloc(1000*60*10)
        
        // Validar que se obtuvo la geolocalización correctamente
        if (!loc || typeof loc.latitude === 'undefined' || typeof loc.longitude === 'undefined') {
            console.error('Error: No se pudo obtener la geolocalización');
            return undefined;
        }
        
        let punto = punto_entrega
        punto = Array.isArray(punto) ? {latitude : punto[0], longitude : punto[1]} : punto
        
        // Validar que el punto de entrega tenga coordenadas válidas
        if (!punto || typeof punto.latitude === 'undefined' || typeof punto.longitude === 'undefined') {
            console.error('Error: Punto de entrega no tiene coordenadas válidas');
            return undefined;
        }
        
        window.fake_console( loc, punto, punto_entrega )
        const lat = (loc.latitude-punto.latitude)*110120
        const lon = (loc.longitude-punto.longitude)*85000
        const dist = Math.ceil(Math.sqrt(Math.pow(lat,2)  +Math.pow(lon,2) )-(loc.accuracy||0))
        window.fake_console(dist, lat, lon )
        if ( dist > 500 ) {
            const confirmacion = await openAlertaDistanciaEntrega(dist)
            return confirmacion === false ? loc : confirmacion
        }
        else {
            return true 
        }
}

const entregaPdvDistance =  async function( pointer_pdv ){
    const loc = await getGeoloc(1000*60*10)
    
    // Validar que se obtuvo la geolocalización correctamente
    if (!loc || typeof loc.latitude === 'undefined' || typeof loc.longitude === 'undefined') {
        console.error('Error: No se pudo obtener la geolocalización');
        await openAlertaDistancia();
        return undefined;
    }
    
    let punto = pointer_pdv
    punto = Array.isArray(punto) ? {latitude : punto[0], longitude : punto[1]} : punto
    
    // Validar que el pointer PDV tenga coordenadas válidas
    if (!punto || typeof punto.latitude === 'undefined' || typeof punto.longitude === 'undefined') {
        console.error('Error: Pointer PDV no tiene coordenadas válidas');
        await openAlertaDistancia();
        return undefined;
    }
    
    window.fake_console( loc, punto, pointer_pdv )
    const lat = (loc.latitude-punto.latitude)*110120
    const lon = (loc.longitude-punto.longitude)*85000
    const dist = Math.ceil(Math.sqrt(Math.pow(lat,2)  +Math.pow(lon,2) )-(loc.accuracy||0))
    window.fake_console(dist, lat, lon )
    if ( dist > 500 ) {
        await openAlertaDistancia()
        return undefined  
    }
    else {
        return true 
    }
}


const DistanciaEnvio =  async function( punto_entrega ){
    const loc = await getGeoloc(1000*60*10)
    
    // Validar que se obtuvo la geolocalización correctamente
    if (!loc || typeof loc.latitude === 'undefined' || typeof loc.longitude === 'undefined') {
        console.error('Error: No se pudo obtener la geolocalización');
        return null; // o un valor por defecto apropiado
    }
    
    let punto = punto_entrega
    punto = Array.isArray(punto) ? {latitude : punto[0], longitude : punto[1]} : punto
    
    // Validar que el punto de entrega tenga coordenadas válidas
    if (!punto || typeof punto.latitude === 'undefined' || typeof punto.longitude === 'undefined') {
        console.error('Error: Punto de entrega no tiene coordenadas válidas');
        return null;
    }
    
    window.fake_console( loc, punto, punto_entrega )
    const lat = (loc.latitude-punto.latitude)*110120
    const lon = (loc.longitude-punto.longitude)*85000
    const dist = Math.ceil(Math.sqrt(Math.pow(lat,2)  +Math.pow(lon,2) )-(loc.accuracy||0))
    //console.log(dist)
    return Math.ceil(dist/100)/10
}



const DistanciaLinealEntrePuntos =   function( objeto_pointers ){

    const {lat_ent, lon_ent, lat_env, lon_env } = objeto_pointers 
    if( !lat_ent||!lat_env||!lon_ent||!lon_env ){
        return undefined
    }
    else 
    {
        const lat = (lat_ent-lat_env)*110120
        const lon = (lon_ent-lon_env)*85000
        const dist = Math.ceil(Math.sqrt(Math.pow(lat,2)  +Math.pow(lon,2) ))
        return Math.ceil(dist)
    }
}



const getGeoloc = async function( maxAge) {
    let maximumAge = maxAge||0
    const atStore = await checkIP()
    if (atStore === true) {
        const pdv_geoloc = await loadStorage('pdv_geoloc')
        const [latitude, longitude] = pdv_geoloc 
        window.fake_console({latitude, longitude, accuracy: 1 , localizacion :'pdv'})
        return {latitude, longitude, accuracy: 1 , localizacion :'pdv'}
    }
    try {
        const permisosGeo = await Geolocation.checkPermissions()
        if (!permisosGeo) {await Geolocation.requestPermissions('camera')}
        const position = await Geolocation.getCurrentPosition({maximumAge});
        window.fake_console(position)
        const {latitude, longitude, accuracy } = position.coords 
        return {latitude, longitude, accuracy } 
            
        }
    catch (error) {
        window.fake_console(error)
        await openAlertaV2 ("Error localizacion",'Tu navegador no soporta la geolocalización') // if the browser doesn't support geolocation
        return 
    }
  

}



 /** Abrir ventana con google maps para identificar el pointer de entrega, 
   *  solo se muestra para repartos. 
   */
 const irGoogleMaps = async function (envio){
    window.fake_console(envio)
    const {lat_env,lon_env} = envio
    //await Browser.open({url:`https://www.google.es/maps/search/${lat_env},${lon_env}?shorturl=1`})
    window.open(`https://www.google.es/maps/search/${lat_env},${lon_env}?shorturl=1`, '_blank', 'noreferrer');
  }

  const RutaGoogleMaps = async function(envio){
    try {
        const position = await getPosition({maximumAge:0})
        
        // Validar que se obtuvo la posición correctamente
        if (!position || !position.coords || typeof position.coords.latitude === 'undefined' || typeof position.coords.longitude === 'undefined') {
            console.error('Error: No se pudo obtener la posición actual');
            await openAlertaV2('Error de ubicación', 'No se pudo obtener tu ubicación actual para calcular la ruta');
            return;
        }
        
        const {latitude, longitude } = position.coords 
        window.fake_console({latitude, longitude})
        
        // Validar que el envío tenga coordenadas válidas
        const {lat_env,lon_env} = envio
        if (typeof lat_env === 'undefined' || typeof lon_env === 'undefined') {
            console.error('Error: El envío no tiene coordenadas válidas');
            await openAlertaV2('Error de destino', 'El destino no tiene coordenadas válidas');
            return;
        }
        
        const destino = `'${lat_env},${lon_env}'`
        const origen = `'${latitude},${longitude}'`
        const goog_url = `https://www.google.com/maps/dir/${origen}/${destino}`
        //await Browser.open({url : goog_url })
        window.open(goog_url, '_blank', 'noreferrer');
    } catch (error) {
        console.error('Error en RutaGoogleMaps:', error);
        await openAlertaV2('Error de ubicación', 'No se pudo obtener tu ubicación actual');
    }
  }





export {getGeoloc, pdvDistance , irGoogleMaps , RutaGoogleMaps , 
    entregaDistance, entregaPdvDistance, DistanciaEnvio , 
    DistanciaLinealEntrePuntos
    }